import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NacinpredavanjaPopisService } from './nacinpredavanja-popis.service';
import { NacinpredavanjaPopis } from './nacinpredavanja';
import { Subject } from 'rxjs';
import * as toastr from 'toastr';
import * as alertify from 'alertify.js';

@Component({
  selector: 'app-nacinpredavanja-popis',
  templateUrl: './nacinpredavanja-popis.component.html',
  styleUrls: ['./nacinpredavanja-popis.component.css'],
  providers: [NacinpredavanjaPopisService]
})
export class NacinpredavanjaPopisComponent implements OnInit {

  sviNacinipredavanja: NacinpredavanjaPopis[] = [];
  nacinpredavanjaOptions: DataTables.Settings = {};
  nacinpredavanjaTrigger: Subject<NacinpredavanjaPopis> = new Subject();

  nacinpredavanjaForma: FormGroup;
  nacinpredavanjaEditForma: FormGroup;

  nacinpredavanjaId: string;

  constructor(
    private _fb: FormBuilder,
    private _nacipredavanjaPopisService: NacinpredavanjaPopisService
  ) { }

  ngOnInit() {
    this.dohvati();
    //Tablica početak
    this.nacinpredavanjaOptions = {
      pagingType: 'full_numbers',
      pageLength: 50,
      responsive: true,
      columnDefs: [{
        targets: 'no-sort',
        orderable: false
      }],
      retrieve: true
    };
    //Tablica kraj
    this.nacinpredavanjaForma = this._fb.group({
      naziv: [''],
    });
    this.nacinpredavanjaEditForma = this._fb.group({
      naziv: [''],
      aktivan: ['']
    });
  }

  pripremiPodatke(nacin){
    //console.log(nacin);
    this.nacinpredavanjaId = nacin['id'];
    this.nacinpredavanjaEditForma = this._fb.group({
      naziv: nacin['naziv'],
      aktivan: nacin['aktivan']
    });
  }

  uredi(nacin){
    //console.log(nacin);
    let podaciZaSlanje = {
      'idnacinpredavanja': this.nacinpredavanjaId,
      'naziv': nacin['naziv'],
      'aktivan': nacin['aktivan'],
      'access_token': localStorage.getItem('tokenSql')
    }
    //console.log(podaciZaSlanje);
    this._nacipredavanjaPopisService.urediNacinpredavanja(podaciZaSlanje).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        $('#nacinpredavanjaTablica').DataTable().destroy();
        this.dohvati();
      } else {
        toastr.error("Neuspješno uređivanje!");
      }
    });
  }

  spremi(nacinpredavanjaForma){
    //console.log(nacinpredavanjaForma);
    let objektZaSlanje = {
      'naziv': nacinpredavanjaForma['naziv']
    }
    //console.log(objektZaSlanje);
    if(nacinpredavanjaForma['naziv']){
      this._nacipredavanjaPopisService.dodajNacinpredavanja(objektZaSlanje).subscribe(res => {
        //console.log(res);
        if(res.success == true){
          toastr.success("Uspješno dodan način predavanja!");
          this.nacinpredavanjaForma = this._fb.group({
            naziv: ['']
          });
          $('#nacinpredavanjaTablica').DataTable().destroy();
          this.dohvati();
        } else {
          toastr.error("Neuspješno spremanje!");
        }
      });
    } else {
      toastr.error("Unesite potrebne podatke!");
    }
  }

  dohvati(){
    this.sviNacinipredavanja = [];
    this._nacipredavanjaPopisService.dohvatiSve({'idkorisnik': localStorage.getItem('userId')}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviNacinipredavanja.push({
            'id': res.data[i]['idnacinpredavanja'],
            'naziv': res.data[i]['np_naziv'],
            'aktivan': res.data[i]['np_aktivan']
          });
        }
        this.nacinpredavanjaTrigger.next();
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  obrisiNacinpredavanja(nacin){
    //console.log(nacin);
    let ovo = this;
    alertify
    .okBtn("Obriši")
    .cancelBtn("Odustani")
    .confirm("Jeste li sigurni da želite obrisati način predavanja?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo._nacipredavanjaPopisService.obrisiNacinpredavanja({'idnacinpredavanja': nacin.id}).subscribe(res => {
          //console.log(res);
          if(res.success == true){
            toastr.success("Način predavanja uspješno obrisan!");
            $('#nacinpredavanjaTablica').DataTable().destroy();
            ovo.dohvati();
          } else {
            toastr.error(res.message);
          }
        })
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste od brisanja načina predavanja.');
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/nacinpredavanja-popis/nacinpredavanja-popis.component.ts